import { render } from "./VendorRankingTitle.vue?vue&type=template&id=5edea0e2&scoped=true"
import script from "./VendorRankingTitle.vue?vue&type=script&lang=js"
export * from "./VendorRankingTitle.vue?vue&type=script&lang=js"

import "./VendorRankingTitle.vue?vue&type=style&index=0&id=5edea0e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edea0e2"]])

export default __exports__